import DependentCheckboxes from '@engine/features/terminal/terminal_dependent_checkboxes';
import RiskFilters from '@engine/features/terminal/terminal_risk_filters';

function listenForModeChange() {
  $('#terminal_mode').on('change', function () {
    $('#terminal_mode_warning').toggleClass('hidden');
  });
}

function listenForMotoCheckboxCheck() {
  $('#feature_require_moto').on('click', function () {
    $('#required_api_param_moto').prop('checked', this.checked);
  });
  $('#required_api_param_moto').on('click', function () {
    $('#feature_require_moto').prop('checked', this.checked);
  });
}

var Terminal = {
  listenForModeChange: listenForModeChange,
  listenForMotoCheckboxCheck: listenForMotoCheckboxCheck,
  DependentCheckboxes: DependentCheckboxes,
  RiskFilters: RiskFilters
};
export default Terminal;